import { Component, OnInit } from '@angular/core';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';
import {FormControl, Validators} from '@angular/forms';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html',
  styleUrls: ['./sign-in.component.css']
})
export class SignInComponent implements OnInit {

  email = new FormControl('', [Validators.required, Validators.email]);
  password = new FormControl('', [Validators.required, Validators.minLength(6)])

  constructor(private auth:AuthService, private router: Router, private _snackBar: MatSnackBar) { }

  ngOnInit() {
  }

  getEmailErrorMessage() {
    if (this.email.hasError('required')) {
      return 'You must enter a value';
    }
    return this.email.hasError('email') ? 'Not a valid email' : '';
  }

  getPasswordErrorMessage() {
    if (this.password.hasError('required')) {
      return 'You must enter a value';
    }

    return this.password.hasError('minlength') ? 'Minimun 6 characters required' : '';
  }

  onSubmit(){
    if(this.email.valid && this.password.valid)
    this.auth.signIn(this.email.value,this.password.value).then(
      (a)=>{
        console.log('This is aey',a);
        this.auth.checkRole(a.user.uid).subscribe(
          (b)=>{
            console.log(b)
            if(b==true){
              localStorage.setItem('role','employer')
              this.router.navigate(['/employer-dashboard'])
            }
            else{
              localStorage.setItem('role','candidate')
              this.router.navigate(['/dashboard'])
            }
          }
        )
      }
    ).catch(
      (a)=>{
        this._snackBar.open(a.message, 'Okay', {
          duration: 5000,
        });
        console.log(a)
      }
    )
  }
}
